import React, { useState } from 'react'
import { Popover } from 'antd-mobile'
import { setLanguageStore } from '../../utils/storage/language'
import { getCurrLang } from "../../locales"

import './index.less'
import BoxIcon from '../Icon/BoxIcon'
import { addBehaviorsRecord } from '../../utils/BehaviorstatsHelp'
import { getUrlHashName } from '../../utils/page'
import { modifyUserInfoModel } from '../../model/store'
import { getMemberInfo } from '../../utils/storage/store'

const items = [
  { key: 'zh_CN', short: 'zh', text: '中文', icon: null },
  { key: 'en_US', short: 'en', text: 'English', icon: null },
  { key: 'th_TH', short: 'th', text: 'ภาษาไทย', icon: null },
]

const SelectLanguage = (props) => {
  const [lanKey, setLanKey] = useState(getCurrLang())
  const { lanItem = {}, storeInfo = {} } = props

  const getShortName = (item) => {
    if (item.indexOf('_') > -1) {
      return item.split('_')[0]
    } else if (item.indexOf('-') > -1) {
      return item.split('-')[0]
    }

  }

  let arr = items
  const lans = Object.keys(lanItem)
  if (lans.length > 0) {
    arr = lans.map(item => {
      return {
        key: item,
        short: getShortName(item),
        text: lanItem[item],
        icon: null
      }
    })
  }

  const curLan = arr.find(item => item.short === getCurrLang()) || arr[0]
  console.log(curLan, '///===curLan==///')

  const doMenuClick = (e) => {
    console.log(e)
    setLanguageStore(e.key)
    //记录切换语言的行为统计
    addBehaviorsRecord({
      behaviorType: 160200,
      behavior: 160202,
      storeId: storeInfo.storeId,
      value1: e.key,
      value2: getUrlHashName()
    })

    modifyUserInfoModel({
      firstName: '',
      lastName: '',
      contactInfo: '',
      memberId: getMemberInfo().memberId,
      language: e.key
    }).then(res => {
      console.log(res)
    })


    window.location.reload()
    // 如果需要回调可以这样使用：
    // const { callback } = props
    // callback && callback(e.key)
  }

  return (
    <div className="lan-container">
      <Popover.Menu
        actions={arr}
        onAction={node => doMenuClick(node)}
        placement='bottom-start'
        trigger='click'
      >
        <div className='jm-flex'>
          <div style={{ width: 60, textAlign: 'right', position: 'relative', marginTop: 2 }}>
            <div className='lan-icon-box'>
              <BoxIcon width={30} height={30} color="var(--adm-color-primary)" />
            </div>
            <span className='lan-icon-bg'>
              <span className='lan-icon-text'>{curLan?.short || ''}</span>
            </span>
          </div>
          {/* <span style={{ fontSize: 14, fontWeight: 400 }}>{curLan.text}</span> */}
          {/* <DownOutline style={{ verticalAlign: 'sub' }} /> */}
        </div>
      </Popover.Menu>
    </div>
  )
}

export default SelectLanguage